<template>
  <div v-if="!isAuthInCurrentRegion">
    <div class="mt-4" v-if="!authShow">
      <b-alert class="mt-4" show variant="secondary">{{
        $t(`authorization_statement_${service}`)
      }}</b-alert>
      <b-button size="lg" variant="primary" @click="openAuth">{{
        $t("auth_iframe_block")
      }}</b-button>
    </div>
    <div class="wrap" v-if="authShow">
        <div class="my-4">
          <h1 class="h3 text-center">
            {{ $t("auth_block") }}
          </h1>
          <b-alert v-if="error" show variant="danger">
            {{ error.description }}
          </b-alert>
          <b-spinner v-if="loading" type="grow" :label="$t('loading')" />
          <b-card-text text>
            <b-form @submit="onSubmit">
              <b-form-group :label="$t('login_auth')" label-for="login">
                <b-form-input
                  id="login"
                  v-model="form.login"
                  type="email"
                  required
                  :disabled="loading"
                  :placeholder="$t('enter_login')"
                />
              </b-form-group>

              <b-form-group :label="$t('password')" label-for="password">
                <b-input-group>
                  <b-form-input
                    id="password"
                    v-model="form.password"
                    :type="showPass ? 'text' : 'password'"
                    required
                    :disabled="loading"
                    :placeholder="$t('enter_password')"
                  />
                  <b-input-group-append>
                    <b-button size="sm" text="Button" @click="showPass = !showPass">
                      <b-icon-eye v-if="showPass" />
                      <b-icon-eye-slash v-if="!showPass" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-button :disabled="loading" type="submit" block variant="primary">
                {{ $t("auth_btn") }}
              </b-button>
            </b-form>
          </b-card-text>
        </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import helper from '../../helper'

export default {
  props: ['source', 'service'],
  data: () => {
    return {
      supportedRegions: helper.hosts.filter((c) => c.available),
      authorized: false,
      authShow: false,
      authLoaded: false,
      error: null,
      showPass: false,
      loading: false,
      token: '',
      form: {
        login: '',
        password: '',
      },
    }
  },
  computed: {
    regionChoosed() {
      return this.$root.$data.state.choosedRegion
    },
    isAuthInCurrentRegion() {
      return (
        this.regionChoosed
        && this.$root.$data.state.auth
        && this.$root.$data.state.auth.token
        && this.$root.$data.state.auth.expTokenJsTimestamp > Date.now()
      )
    },
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault()
      if (!this.regionChoosed) {
        return
      }
      this.loading = true
      try {
        axios.post(`${this.regionChoosed.hosts.auth_api}/api/front/public/auth`, {
          login: this.form.login,
          password: this.form.password,
          source: 'cws',
          lang: this.$i18n.locale,
          cross_origin: true,
        }).then((res) => res.data)
          .then((res) => {
            try {
              const token = {
                expTokenJsTimestamp: res.data.expTokenJsTimestamp,
                token: res.data.token,
              }
              this.authorized = true
              this.authShow = false
              this.$root.$data.setAuth({ ...token })
              localStorage.setItem(
                'cross_region_auth',
                JSON.stringify({ ...token }),
              )
              this.checkAuth()
            } catch (error) {
              this.error = {
                type: this.$t('server_error'),
                description: error.message,
              }
            }
          })
          .catch((error) => {
            const { response } = error
            if (response && response.status !== 500) {
              this.error = response.data.error
            } else {
              this.error = {
                type: this.$t('server_error'),
                description: this.$t('try_again_later'),
                exeption: error.message,
                stack: error.stack,
              }
              console.error('catch fatal auth error', error)
            }
          })

        /*
        this.supportedRegions.forEach((region) => {
          axios.post(`${region.hosts.auth_api}/api/front/public/auth`, {
            login: this.form.login,
            password: this.form.password,
            source: 'cws',
            lang: this.$i18n.locale,
          }).then((res) => res.data)
            .then((res) => {
              try {
                const token = {
                  expTokenJsTimestamp: res.data.expTokenJsTimestamp,
                  token: res.data.token,
                }
                localStorage.setItem(
                  `auth_${region.code}`,
                  JSON.stringify({ ...token }),
                )
                if (!this.authorized) {
                  this.authorized = true
                  this.authShow = false
                  this.$root.$data.setAuth({ ...token })
                  localStorage.setItem(
                    'cross_region_auth',
                    JSON.stringify({ ...token }),
                  )
                  this.checkAuth()
                }
              } catch (error) {
                this.error = {
                  type: this.$t('server_error'),
                  description: error.message,
                }
              }
            })
            .catch((error) => {
              const { response } = error
              if (response && response.status !== 500) {
                this.error = response.data.error
              } else {
                this.error = {
                  type: this.$t('server_error'),
                  description: this.$t('try_again_later'),
                  exeption: error.message,
                  stack: error.stack,
                }
                console.error('catch fatal auth error', error)
              }
            })
        })
        */
      } catch (error) {
        console.error('catch fatal auth error', error)
      } finally {
        this.loading = false
      }
    },
    checkAuth() {
      const region = this.$root.$data.state.choosedRegion
      if (!region) {
        return
      }
      this.loading = true
      // let authObject = this.$root.$data.state.auth[region.code]
      let authObject = this.$root.$data.state.auth
      if (!authObject) {
        // authObject = localStorage.getItem(`auth_${region.code}`)

        authObject = localStorage.getItem('cross_region_auth')
        if (authObject) {
          authObject = JSON.parse(authObject)
        }
      }
      if (!authObject) {
        this.$emit('authorized', false)
        this.loading = false
        return
      }

      if (
        authObject
        && authObject.expTokenJsTimestamp
        && authObject.expTokenJsTimestamp > Date.now()
      ) {
        this.$root.$data.setAuth(authObject)
      } else {
        this.$emit('authorized', false)
        this.loading = false
        return
      }
      this.loading = false
    },
    openAuth() {
      if (!this.$root.$data.state.choosedRegion) {
        this.$root.$data.toggleRegionSelection()
        return
      }
      this.authShow = true
      this.authLoaded = false
    },
  },
  mounted() {
    this.checkAuth()
  },
}
</script>

<style lang="scss">
.frame {
  border: none;
  width: 100%;
  height: 100%;
  outline: none;
  min-height: 100vh;
}
.wrap {
  width: 100%;
  height: 100%;
  min-height: 100vh;
}
.auth_modal {
  .modal-body {
    padding: 0.1rem;
  }
}
</style>
